import React, { useContext, useState } from 'react';
import get from 'lodash/get';
import { CloseOutline, ExclamationCircleOutline } from 'antd-mobile-icons';
import { Popup, NavBar, Button } from 'antd-mobile';
import styled from 'styled-components';
import InputComponent from './Input';
import CustomFieldInputItem from './CustomFieldsInput';
import { OBJECT_TYPE_ADDITIONAL_WORK } from '../utils/constants';
import UserSelfContext from '../utils/self-context';
import { getCustomFields } from '../utils/helpers';


const DefectContent = styled.div`
	margin-bottom: 12px;
	flex: 1;
	min-height: 0;
	overflow: auto;
	width: 100%;
	background: #f0f2f5;
	margin-top: 
`;

const PopoverContent = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const Save = styled(Button)`
	font-size: 17px;
`;

const Nav = styled(NavBar)`
	background: #fff;
	display: flex;
	border-bottom: solid 1px var(--adm-color-border);
`;

function AddDefectPopup(props) {
	const {
		initialValues,
		visible,
		onClose,
		saving,
		onSave
	} = props;
	const [values, setValues] = useState(initialValues || {});
	const { userSelf } = useContext(UserSelfContext);


	async function onSaveClick() {
		const saveValues = values;


		const data = {
			...saveValues
		};

		onSave(data);
	}

	async function onValueChange(data) {
		setValues({ ...values, ...data });
	}

	return (
		<Popup
			destroyOnClose
			position='right'
			visible={visible}
			bodyStyle={{ width: '100%', background: '#f0f2f5' }}
			onClose={onClose}
		>
			<PopoverContent>
				<Nav
					backArrow={<CloseOutline />}
					onBack={onClose}
					back={''}
					right={<Save fill='none' loading={saving} onClick={onSaveClick}>Save</Save>}
				>
					{'Add Additional Work'}
				</Nav>
				<DefectContent>
					<InputComponent
						placeholder="Description"
						onSave={onValueChange}
						dataKey="description"
						title="Description"
						isRequired={true}
						type="text"
						initialValue={values.description}
					/>
					<InputComponent
						placeholder="Rectification method"
						onSave={onValueChange}
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						dataKey="restification_method"
						title="Rectification method"
						type="text"
						initialValue={values.restification_method}
					/>
					<InputComponent
						placeholder="Reference"
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						onSave={onValueChange}
						dataKey="reference"
						title="Reference"
						type="text"
						initialValue={values.reference}
					/>
					<InputComponent
						placeholder="ATA"
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						onSave={onValueChange}
						dataKey="ata"
						title="ATA"
						initialValue={values.ata}
					/>
					<InputComponent
						placeholder="Category"
						onSave={onValueChange}
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						dataKey="category"
						initialValue={[values.category]}
						title="Category"
						type="select"
						options={[
							...(get(userSelf, 'settings.maintenance_item_categories') || []).map(t => ({ label: t, value: t }))
						]}
					/>
					<InputComponent
						placeholder="Critical task"
						onSave={onValueChange}
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						dataKey="critical"
						type="switch"
						getCustomDisplayValue={val => (val ? <span style={{ color: '#ff411c', fontWeight: 'bold' }}><ExclamationCircleOutline /> Yes</span> : <span>No</span>)}
						initialValue={values.critical}
						title="Critical task"
					/>
					{(getCustomFields(userSelf, OBJECT_TYPE_ADDITIONAL_WORK))
						.map(field => (
							<CustomFieldInputItem
								key={field.key}
								model={values}
								field={field}
								onSave={onValueChange}
							/>
						))}
					<InputComponent
						placeholder="Type comment"
						onSave={onValueChange}
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						dataKey="comment"
						initialValue={values.comment}
						title="Comment"
						type="text"
					/>
					<InputComponent
						onSave={onValueChange}
						dataKey="done_date"
						title="Done date"
						requiredRulesObjectType={OBJECT_TYPE_ADDITIONAL_WORK}
						type="date"
						initialValue={values.done_date}
					/>
				</DefectContent>
			</PopoverContent>
		</Popup>
	);
}

export default AddDefectPopup;
